// window.onload = function() {

//   var playButton = document.querySelector('video');
//   if ( playButton ) {
//     playButton.click();
//     window.scrollBy(0,2);
//     document.addEventListener("scroll", (event) => {
//       var videoelem = document.querySelector('video');
//         videoelem.play();
//     });
//     document.addEventListener("touchstart", (event) => {
//       var videoelem = document.querySelector('video');
//         videoelem.play();
//     });
//   }

// };
(function ($) {
  $(document).ready(function () {
    console.log("jsfile");

    // // Globo Product Option validation
    // function validateGloboRequiredFields() {
    //   let isValid = true;
    //   let errorMessage = "";

    //   // Find all Globo Product Option required fields
    //   const requiredFields = document.querySelectorAll(
    //     '.gpo-input[data-name*="properties[שם משפחה]"], .gpo-input[data-name*="properties[מספר בית]"]'
    //   );

    //   requiredFields.forEach(function (field) {
    //     const fieldName = field.getAttribute("data-field-name");
    //     const fieldValue = field.value.trim();

    //     // Check if field is required (has required class or is marked as required)
    //     const isRequired =
    //       field.closest(".gpo-element").querySelector(".gpo-label.required") !==
    //         null ||
    //       field.hasAttribute("required") ||
    //       field.getAttribute("presence") === "required" ||
    //       field.getAttribute("presence") === "mandatory";

    //     if (isRequired && fieldValue === "") {
    //       isValid = false;
    //       field.classList.add("error");

    //       // Add error message to the messages div
    //       const messagesDiv = field
    //         .closest(".gpo-element")
    //         .querySelector(".messages");
    //       if (messagesDiv) {
    //         messagesDiv.innerHTML = '<div class="error">שדה זה הוא חובה</div>';
    //         messagesDiv.style.display = "block";
    //       }

    //       // Check if field is visible in viewport
    //       const fieldRect = field.getBoundingClientRect();
    //       const isVisible =
    //         fieldRect.top >= 0 && fieldRect.bottom <= window.innerHeight;

    //       if (!isVisible) {
    //         // Smooth scroll to field without hiding it under header
    //         setTimeout(() => {
    //           const headerHeight =
    //             document.querySelector("header")?.offsetHeight || 0;
    //           const scrollTop =
    //             window.pageYOffset || document.documentElement.scrollTop;
    //           const targetScrollTop =
    //             scrollTop + fieldRect.top - headerHeight - 20; // 20px padding

    //           window.scrollTo({
    //             top: targetScrollTop,
    //             behavior: "smooth",
    //           });

    //           // Focus after scroll
    //           setTimeout(() => {
    //             field.focus();
    //           }, 300);
    //         }, 100);
    //       } else {
    //         // Field is already visible, just focus
    //         setTimeout(() => {
    //           field.focus();
    //         }, 100);
    //       }

    //       if (fieldName === "שם משפחה") {
    //         errorMessage = "שם משפחה הוא שדה חובה";
    //       } else if (fieldName === "מספר בית") {
    //         errorMessage = "מספר בית הוא שדה חובה";
    //       } else {
    //         errorMessage = "יש למלא את כל השדות החובה";
    //       }
    //     } else {
    //       field.classList.remove("error");
    //       const messagesDiv = field
    //         .closest(".gpo-element")
    //         .querySelector(".messages");
    //       if (messagesDiv) {
    //         messagesDiv.innerHTML = "";
    //         messagesDiv.style.display = "none";
    //       }
    //     }
    //   });

    //   // if (!isValid && errorMessage) {
    //   //   alert(errorMessage);
    //   // }

    //   return isValid;
    // }

    // // Add validation to all forms with Globo Product Option
    // document.addEventListener("submit", function (event) {
    //   const form = event.target;

    //   // Check if this is a product form with Globo Product Option
    //   if (
    //     form.classList.contains("product-form") ||
    //     form.querySelector(".gpo-input")
    //   ) {
    //     if (!validateGloboRequiredFields()) {
    //       event.preventDefault();
    //       return false;
    //     }
    //   }
    // });

    // // Add validation to add to cart buttons
    // document.addEventListener("click", function (event) {
    //   if (event.target.matches('button[type="submit"], input[type="submit"]')) {
    //     const form = event.target.closest("form");
    //     if (
    //       form &&
    //       (form.classList.contains("product-form") ||
    //         form.querySelector(".gpo-input"))
    //     ) {
    //       if (!validateGloboRequiredFields()) {
    //         event.preventDefault();
    //         return false;
    //       }
    //     }
    //   }
    // });

    // // Clear validation errors when user starts typing
    // document.addEventListener("input", function (event) {
    //   if (event.target.classList.contains("gpo-input")) {
    //     event.target.classList.remove("error");
    //     const messagesDiv = event.target
    //       .closest(".gpo-element")
    //       .querySelector(".messages");
    //     if (messagesDiv) {
    //       messagesDiv.innerHTML = "";
    //       messagesDiv.style.display = "none";
    //     }
    //   }
    // });

    let collectionBottomText = document.querySelector(
      ".collection_bottom_text"
    );
    if (collectionBottomText) {
      let elems = collectionBottomText.querySelectorAll(
        ".metafield-rich_text_field > *"
      );
      let sumHeight = elems[0].offsetHeight + elems[1].offsetHeight;
      let container = collectionBottomText.querySelector(
        ".metafield-rich_text_field"
      );
      if (sumHeight > 80) {
        container.style.height = `${sumHeight}px`;
        container.style.overflow = "hidden";
        const node = document.createElement("a");
        node.setAttribute("href", "#");
        node.classList.add("togglerRM");
        node.innerHTML = "Read more";
        container.closest(".prose").firstChild.appendChild(node);
        node.addEventListener("click", function (e) {
          e.preventDefault();
          if (!node.classList.contains("is-active")) {
            container.style.height = `auto`;
            container.style.overflow = "visible";
            node.innerHTML = "Read less";
            node.classList.add("is-active");
          } else {
            container.style.height = `${sumHeight}px`;
            container.style.overflow = "hidden";
            node.innerHTML = "Read more";
            node.classList.remove("is-active");
          }
        });
      }
    }

    $(window).on("scroll", function (e) {
      showSizes();
    });
    function showSizes() {
      var windowWidth = $(window).width();
      var windowHeight = $(window).height();

      var centerX = windowWidth / 4;
      var centerY = windowHeight / 2;

      var elementsInCenter = document.elementsFromPoint(centerX, centerY);
      let centeredProductId = $(elementsInCenter[0]).closest(".product-card");

      // alert(centerY);
      let secondCentered = centeredProductId.prev();
      if (centeredProductId && centeredProductId.length > 0) {
        $(".firintest").removeClass("firintest");
        centeredProductId.addClass("firintest");
      }

      if (secondCentered && secondCentered.length > 0) {
        secondCentered.addClass("firintest");
      }
    }
    if ($(".swiper.loop_card .swiper-slide").length > 1) {
      let in_loop_slider = new Swiper(".swiper.loop_card", {
        slidesPerView: 1,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
          renderBullet: function (index, className) {
            var slidesCount = this.slides.length;
            var bulletWidth = 100 / slidesCount;

            return (
              '<span class="' +
              className +
              '" style="width:' +
              bulletWidth +
              '%"></span>'
            );
          },
        },
      });
    }
    document.addEventListener("facet:update", function () {
      if ($(".swiper.loop_card .swiper-slide").length > 1) {
        let in_loop_slider = new Swiper(".swiper.loop_card", {
          slidesPerView: 1,
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
            clickable: true,
            renderBullet: function (index, className) {
              var slidesCount = this.slides.length;
              var bulletWidth = 100 / slidesCount;

              return (
                '<span class="' +
                className +
                '" style="width:' +
                bulletWidth +
                '%"></span>'
              );
            },
          },
        });
      }
    });

    let sizeAddToCart = document.querySelectorAll(
      ".product-variant-dropdown li"
    );

    sizeAddToCart.forEach(function (elem) {
      elem.addEventListener("click", addToCartVariant);
    });

    async function addToCartVariant() {
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:start", { bubbles: true })
      );
      let sectionsToBundle = [];
      document.documentElement.dispatchEvent(
        new CustomEvent("cart:prepare-bundled-sections", {
          bubbles: true,
          detail: { sections: sectionsToBundle },
        })
      );

      let form = this.querySelector("form");
      const formData = new FormData(form);
      formData.set("sections", sectionsToBundle.join(","));
      formData.set(
        "sections_url",
        `${Shopify.routes.root}variants/${this.id.value}`
      );
      const response = await fetch(`${Shopify.routes.root}cart/add.js`, {
        body: formData,
        method: "POST",
        headers: {
          "X-Requested-With": "XMLHttpRequest",
          // Needed for Shopify to check inventory
        },
      });
      console.log(response);

      const responseJson = await response.json();
      document.documentElement.dispatchEvent(
        new CustomEvent("theme:loading:end", { bubbles: true })
      );
      if (response.ok) {
        if (
          window.themeVariables.settings.cartType === "page" ||
          window.themeVariables.settings.pageType === "cart"
        ) {
          return (window.location.href = `${Shopify.routes.root}cart`);
        }
        const cartContent = await (
          await fetch(`${Shopify.routes.root}cart.js`)
        ).json();
        cartContent["sections"] = responseJson["sections"];
        this.dispatchEvent(
          new CustomEvent("variant:add", {
            bubbles: true,
            detail: {
              items: responseJson.hasOwnProperty("items")
                ? responseJson["items"]
                : [responseJson],
              cart: cartContent,
              onSuccessDo: formData.get("on_success"),
            },
          })
        );
        document.documentElement.dispatchEvent(
          new CustomEvent("cart:change", {
            bubbles: true,
            detail: {
              baseEvent: "variant:add",
              onSuccessDo: formData.get("on_success"),
              cart: cartContent,
            },
          })
        );
      } else {
        this.dispatchEvent(
          new CustomEvent("cart:error", {
            bubbles: true,
            detail: {
              error: responseJson["description"],
            },
          })
        );
      }
    }
    /*
     * submenu go to page on click and on plus go to submenu
     */
    let buttons = document.querySelectorAll(".subMenuBtn");
    buttons.forEach(function (elem) {
      elem.addEventListener("click", goAway);
    });
    function goAway(elem) {
      let newLink = this.getAttribute("href");
      window.location.href = newLink;
    }

    //newsletter add birthday to tags
    let birthday = document.querySelector('[name="contact[birthday]"]');
    if (birthday) {
      birthday.addEventListener("change", function () {
        let tags = document.querySelector('[name="contact[tags]"]');
        let oldVal = tags.value;
        const date = new Date(this.value);
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        const formattedDate = `${month}/${day}`;
        tags.value = `Birthday:${formattedDate}, newsletter`;
        // console.log(this.value);
      });
    }
  });

  function handleScroll() {
    if (window.scrollY > 40) {
      document.body.classList.add("am-scroll");
    } else {
      document.body.classList.remove("am-scroll");
    }
  }
  window.addEventListener("scroll", handleScroll);
})(window.jQuery);
